export default __webpack_public_path__ + "resources/icons/d600-8a0e.png";